module.exports = __webpack_public_path__ + "img/185.furnichers.2e133901.svg";